import { AugmentationPanelLegacyForm } from "@pathwright/ux/src/components/augmentation/AugmentationPanelLegacyForm"
import { useParams } from "react-router-dom"
import { MentorGroupMembershipSettingsContainer } from "../members/list/MentorGroupMembershipSettingsCard"

function GroupMemberMembershipAugmentation({ groupId }: { groupId: number }) {
  const { manageMember } = useParams<{
    manageMember: string
  }>()

  return (
    <AugmentationPanelLegacyForm>
      <MentorGroupMembershipSettingsContainer
        membershipId={parseInt(manageMember?.match(/\d+/)?.[0]!)}
        groupId={groupId}
      />
    </AugmentationPanelLegacyForm>
  )
}

export default GroupMemberMembershipAugmentation
